export default __webpack_public_path__ + "static/media/corner.26b4541c.png";